import PropTypes from 'prop-types';
import React from 'react';

import VM from 'scratch-vm';

import classNames from 'classnames';
import SpriteLibrary from '../../containers/sprite-library.jsx';
import SpriteSelectorComponent from '../sprite-selector/sprite-selector.jsx';
import StageSelector from '../../containers/stage-selector.jsx';
import { STAGE_DISPLAY_SIZES } from '../../lib/layout-constants';
import SpriteList from '../sprite-selector/sprite-list.jsx';
import ActionMenu from '../action-menu/action-menu.jsx';
import Robotlibrary from '../robot-library/robot-library.jsx';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Box from '../box/box.jsx';

import robottp from './icon-robot.png';
import UploadIcon from '../action-menu/icon--file-upload.svg';

import styles from './target-pane.css';
/*
 * Pane that contains the sprite selector, sprite info, stage selector,
 * and the new sprite, costume and backdrop buttons
 * @param {object} props Props for the component
 * @returns {React.Component} rendered component
 */

const messages = defineMessages({
    selectionRobot: {
        id: 'gui.gui.selectionRobot',
        description: 'Choose a Robot Suit',
        defaultMessage: 'Choose a Robot Suit'
    }
});
const TargetPane = ({
    editingTarget,
    tabsActiveIndex,
    fileInputRef,
    hoveredTarget,
    spriteLibraryVisible,
    onActivateBlocksTab,
    onChangeSpriteDirection,
    onChangeSpriteName,
    onChangeSpriteRotationStyle,
    onChangeSpriteSize,
    onChangeSpriteVisibility,
    onChangeSpriteX,
    onChangeSpriteY,
    onDeleteSprite,
    onDrop,
    onDuplicateSprite,
    onExportSprite,
    onFileUploadClick,
    onNewSpriteClick,
    onPaintSpriteClick,
    onRequestCloseSpriteLibrary,
    onSelectSprite,
    onSpriteUpload,
    onSurpriseSpriteClick,
    raiseSprites,
    onSetActiveId,
    stage,
    stageSize,
    sprites,
    robot,
    onNewRobotClick,
    activeId,
    isUploadE7,
    onSetUploadModal,
    vm,
    intl,
    link,
    isRtl,
    ...componentProps
}) => (
    <div
        className={styles.targetPane}
        {...componentProps}
    >
        {/* {tabsActiveIndex} */}
        <div className={classNames(styles.robotSelector, { [styles.tabsActive]: tabsActiveIndex == 0 })}>
            <div className={styles.robotTitle}>
                <span>
                    <FormattedMessage
                        defaultMessage="Robot"
                        description="Robot Title"
                        id="gui.gui.robotTab"
                    />
                </span>
            </div>

            <Box className={styles.scrollWrapper}>
                <SpriteList
                    editingTarget={editingTarget}
                    hoveredTarget={hoveredTarget}
                    items={Object.keys(robot).map(id => robot[id])}
                    raised={raiseSprites}
                    selectedId={editingTarget}
                    onDeleteSprite={onDeleteSprite}
                    onDrop={onDrop}
                    // onDuplicateSprite={onDuplicateSprite}
                    // onExportSprite={onExportSprite}
                    onSelectSprite={onSelectSprite}
                    link={link}
                />
            </Box>
            {
                vm.editingTarget && vm.editingTarget.robotType === "E7" ? (
                    <ActionMenu
                        className={styles.upload}
                        img={UploadIcon}
                        title={'资源管理'}
                        onClick={() => {
                            if (isUploadE7) {
                                onSetUploadModal(false)
                            } else {
                                onSetUploadModal(true)
                            }
                        }}
                        tooltipPlace={isRtl ? "right" : "left"}
                    />
                ) : null
            }
            <ActionMenu
                className={styles.addButton}
                img={robottp}
                title={intl.formatMessage(messages.selectionRobot)}
                onClick={onNewRobotClick}
                tooltipPlace={isRtl ? "right" : "left"}
            />
        </div>
        <SpriteSelectorComponent
            tabsActiveIndex={tabsActiveIndex}
            editingTarget={editingTarget}
            hoveredTarget={hoveredTarget}
            raised={raiseSprites}
            selectedId={editingTarget}
            spriteFileInput={fileInputRef}
            sprites={sprites}
            stageSize={stageSize}
            onChangeSpriteDirection={onChangeSpriteDirection}
            onChangeSpriteName={onChangeSpriteName}
            onChangeSpriteRotationStyle={onChangeSpriteRotationStyle}
            onChangeSpriteSize={onChangeSpriteSize}
            onChangeSpriteVisibility={onChangeSpriteVisibility}
            onChangeSpriteX={onChangeSpriteX}
            onChangeSpriteY={onChangeSpriteY}
            onDeleteSprite={onDeleteSprite}
            onDrop={onDrop}
            onDuplicateSprite={onDuplicateSprite}
            onExportSprite={onExportSprite}
            onFileUploadClick={onFileUploadClick}
            onNewSpriteClick={onNewSpriteClick}
            onPaintSpriteClick={onPaintSpriteClick}
            onSelectSprite={onSelectSprite}
            onSpriteUpload={onSpriteUpload}
            onSurpriseSpriteClick={onSurpriseSpriteClick}
        />

        <div className={classNames(styles.stageSelectorWrapper, { [styles.tabsActive]: tabsActiveIndex == 2 })}>
            {stage.id && <StageSelector
                asset={
                    stage.costume &&
                    stage.costume.asset
                }
                backdropCount={stage.costumeCount}
                id={stage.id}
                selected={stage.id === editingTarget}
                onSelect={onSelectSprite}
            />}
            <div>

                {spriteLibraryVisible ? (
                    <SpriteLibrary
                        vm={vm}
                        onActivateBlocksTab={onActivateBlocksTab}
                        onRequestClose={onRequestCloseSpriteLibrary}
                    />
                ) : null}
            </div>
        </div>
    </div>
);

const spriteShape = PropTypes.shape({
    costume: PropTypes.shape({
        url: PropTypes.string,
        name: PropTypes.string.isRequired,
        // The following are optional because costumes uploaded from disk
        // will not have these properties available
        bitmapResolution: PropTypes.number,
        rotationCenterX: PropTypes.number,
        rotationCenterY: PropTypes.number
    }),
    direction: PropTypes.number,
    id: PropTypes.string,
    name: PropTypes.string,
    order: PropTypes.number,
    size: PropTypes.number,
    visibility: PropTypes.bool,
    x: PropTypes.number,
    y: PropTypes.number
});

TargetPane.propTypes = {
    editingTarget: PropTypes.string,
    extensionLibraryVisible: PropTypes.bool,
    fileInputRef: PropTypes.func,
    hoveredTarget: PropTypes.shape({
        hoveredSprite: PropTypes.string,
        receivedBlocks: PropTypes.bool
    }),
    onActivateBlocksTab: PropTypes.func.isRequired,
    onChangeSpriteDirection: PropTypes.func,
    onChangeSpriteName: PropTypes.func,
    onChangeSpriteRotationStyle: PropTypes.func,
    onChangeSpriteSize: PropTypes.func,
    onChangeSpriteVisibility: PropTypes.func,
    onChangeSpriteX: PropTypes.func,
    onChangeSpriteY: PropTypes.func,
    onDeleteSprite: PropTypes.func,
    onDrop: PropTypes.func,
    onDuplicateSprite: PropTypes.func,
    onExportSprite: PropTypes.func,
    onFileUploadClick: PropTypes.func,
    onNewSpriteClick: PropTypes.func,
    onPaintSpriteClick: PropTypes.func,
    onRequestCloseExtensionLibrary: PropTypes.func,
    onRequestCloseSpriteLibrary: PropTypes.func,
    onSelectSprite: PropTypes.func,
    onSpriteUpload: PropTypes.func,
    onSurpriseSpriteClick: PropTypes.func,
    raiseSprites: PropTypes.bool,
    spriteLibraryVisible: PropTypes.bool,
    sprites: PropTypes.objectOf(spriteShape),
    robot: PropTypes.objectOf(spriteShape),
    onNewRobotClick: PropTypes.func,
    stage: spriteShape,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    vm: PropTypes.instanceOf(VM)
};

export default TargetPane;
